export const SET_SIGNATURE = 'SET_SIGNATURE'
export const SET_COSIGNER = 'SET_COSIGNER'
export const SET_CONTENT = 'SET_CONTENT'
export const SET_TERM = 'SET_TERM'
export const SET_TEACHER = 'SET_TEACHER'
export const SET_INSTITUTION = 'SET_INSTITUTION'
export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const RESET_STATE = 'RESET_STATE'
